/** "1 card", "2 cards" — plain English plural for the common regular-noun case. */
export const pluralize = (count: number, noun: string): string =>
  `${count} ${noun}${count === 1 ? "" : "s"}`;

/** "1 patient policy", "1,562 patient policies": thousands separated, irregular plural allowed. */
export const formatCount = (
  count: number,
  noun: string,
  plural = `${noun}s`
): string => `${count.toLocaleString("en-US")} ${count === 1 ? noun : plural}`;
